import React from 'react'
import PropTypes from 'prop-types'
import { classNames, Icon, iconProps } from '@zambezi/sdk/common'

/**
 * Create a React Progress Indicator component
 *
 * @param {import('./interfaces').ProgressIndicatorProps} props
 * @returns {JSX.Element}
 */
function ProgressIndicator ({ data, selectedIndex, iconProps }) {
  return (
    <div className='zb-progress-indicator'>
      <ol className='zb-steps'>{data.map(renderStep)}</ol>
    </div>
  )

  /**
   * @param {import('react').ReactNode} step
   * @param {number} index
   * @returns {JSX.Element}
   */
  function renderStep (step, index) {
    const isPast = index < selectedIndex
    const isCurrent = index === selectedIndex

    const cn = classNames('zb-step', {
      'zb-step-is-past': isPast,
      'zb-step-is-selected': isCurrent
    })

    return (
      <li className={cn} key={index}>
        <div className='zb-step-inner'>
          <span className='zb-step-index'>
            {isPast ? (
              <span className='zb-step-metadata-info'>Completed:</span>
            ) : (
              undefined
            )}
            {isCurrent ? (
              <span className='zb-step-metadata-info'>Current:</span>
            ) : (
              undefined
            )}
            {isPast ? (
              <Icon
                name='core-progress-indicator-completed'
                title={String(index + 1)}
                iconProps={iconProps}
              />
            ) : (
              index + 1
            )}
          </span>
          <span className='zb-step-description'>{step}</span>
        </div>
      </li>
    )
  }
}

ProgressIndicator.defaultProps = {
  data: [],
  selectedIndex: -1
}

ProgressIndicator.propTypes = {
  data: PropTypes.array,
  selectedIndex: PropTypes.number,
  iconProps
}

export default ProgressIndicator
